import { Component, Inject, Injector, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ProcedureService } from 'app/core/http/services/procedure.service';
import { DialogData } from 'app/core/interfaces/dialog';
import { BaseComponent } from 'app/modules/shared/components/base.component';
import { PractitionerOrganizationAffiliationService } from 'app/core/http/services/practititoner-organization-affiliation.service';
import { Healthcareservice } from 'app/core/interfaces/healthcareservice';
import { add } from 'date-fns';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';

@Component({
  selector: 'src-select-procedure',
  templateUrl: './select-procedure.component.html',
  styleUrls: ['./select-procedure.component.css'],
})
export class SelectProcedureComponent extends BaseComponent implements OnInit {
  public healthcareSelected: Healthcareservice[] = [];
  public healthcareservice: Healthcareservice[] = [];

  public organizationSelected: any = {};
  public practitioner: any = {};
  public specialtysPractitionerOrganizationIds: string[] = [];

  public address !: any

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private healthcareService: ProcedureService,
    private practitionerOrganizationAffiliationService: PractitionerOrganizationAffiliationService,
    private injector: Injector
  ) {
    super(injector);
  }

  ngOnInit(): void {
    if (this.data?.param?.organization) {
      this.organizationSelected = this.data?.param?.organization;
      this.address = this.data?.param.location?.address[0] ?? {}
    }
    this.practitioner = this.currentUser.user;
    this.getAffiliationPractitionerOrganization();
    this.getHealthcareService();
  }

  getAffiliationPractitionerOrganization() {
    const organization_id = this.organizationSelected.organization_id;
    const practitioner_id = this.getUserLogged().id;

    this.practitionerOrganizationAffiliationService.listByPractitionerOrganization(organization_id, practitioner_id).subscribe({
      next: (resPractitioner: any) => {
        this.specialtysPractitionerOrganizationIds = resPractitioner.specialty
          .filter((specialty: any) => specialty.status == 'accepted' || specialty.status == 'requested')
          .map((specialty: any) => specialty.id);

        this.getHealthcareService();
      },
      error: (err) => {
        console.log('Falha ao listar especialista', err);
      },
    });
  }
 

  getHealthcareService() {
    this.healthcareService.listByOrganizations(this.organizationSelected.organization_id).subscribe({
      next: (resHealth: Healthcareservice[]) => {
        this.healthcareservice = resHealth.filter(healthcareservice => healthcareservice.serviceDealer == "Especialista" );
      },
      error: (err) => {
        console.log('Falha ao listar healthcare Service', err);
      },
    });
  }

  createAffiliation() {
    const organizationFilter = {
      organization_id: this.organizationSelected.organization_id,
      organization_name: this.organizationSelected.name,
      organization_photo: this.organizationSelected.photo,
      organization_address: this.address,
    };

    const practitionerFilter = {
      practitioner_id: this.practitioner.id,
      practitioner_name: this.practitioner.name,
      practitioner_photo: this.practitioner.photo,
      practitioner_details: {
        accessibilities: this.practitioner.accessibilities,
        address: this.practitioner.address,
        communication: this.practitioner.communication,
        cpf: this.practitioner.cpf,
        qualification: this.practitioner.qualification,
        birthDate: this.practitioner.birthDate,
        gender: this.practitioner.gender,
        indentifiers: this.practitioner.identifiers
      },
    };

    const specialty = this.healthcareSelected.map(function (healthcareservice: any) {
      return {
        id: healthcareservice.healthcareservice_id,
        referenceType: 'Healthcareservice',
        display: healthcareservice.name,
        averageDuration: healthcareservice.averageDuration ?? "30",
        status: 'requested',
      };
    });

    const currentDate = new Date().toISOString();

    const affiliation = {
      ...organizationFilter,
      ...practitionerFilter,
      specialty: specialty,
      requestDateTime: currentDate,
      updateDateTime: currentDate,
      status: "requested"
    };

    const organizationPratitionerAfffiliationFHIR = this.transformObjectToFHIR(affiliation);

    this.practitionerOrganizationAffiliationService.create(organizationPratitionerAfffiliationFHIR).subscribe({
      next: (resAffiliation) => {
        location.reload()
      },
      error: (response: HttpErrorResponse) => {
        this.showErrorMessage = true
        this.messageError = response.message
      },
    });
  }

  isAlreadyLinked(item: Healthcareservice): boolean {
    return this.specialtysPractitionerOrganizationIds.includes(item.healthcareservice_id);
  }

  public transformObjectToFHIR(data: any) {
    return {
      resourceType: 'Affiliation',
      request: {
        id: data.practitioner_id,
        referenceType: 'Practitioner',
        display: data.practitioner_name,
        photo: data.practitioner_photo,
        details: data.practitioner_details
      },
      subject: {
        id: data.organization_id,
        referenceType: 'Organization',
        display: data.organization_name,
        photo: data.organization_photo,
        address: data.organization_address,
      },
      specialty: data.specialty,
      requestDateTime: data.requestDateTime,
      updateDateTime: data.updateDateTime,
      status: data.status
    };
  }
}
